import React from 'react';
import { Clock } from 'lucide-react';
export function StickyAlertBar() {
  return <div className="sticky top-0 z-50 w-full bg-deep-black text-white py-3 px-4 shadow-md" data-id="element-205">
      <div className="max-w-7xl mx-auto flex items-center justify-center text-xs sm:text-sm font-inter tracking-wide text-center" data-id="element-206">
        <Clock className="w-4 h-4 mr-2 text-red-500" data-id="element-207" />
        <span data-id="element-208">
          <strong className="text-red-500 font-bold drop-shadow-[0_0_8px_rgba(239,68,68,0.7)]" data-id="element-209">
            HOT SALE: 75% OFF + 2 BONUS POR HOY
          </strong>
        </span>
      </div>
    </div>;
}